import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import path from '../Assets/path.png'
import img from '../Assets/g.png'
import icon4 from '../Assets/Vector.png'
import icon5 from '../Assets/tree.png'
import icon6 from '../Assets/villa-svgrepo-com 1.png'
import img2 from '../Assets/why.png'
import img4 from '../Assets/girl.png'
import comma from '../Assets/66b9ff80d242858b70d662e9_Vector.svg.png'
import img5 from '../Assets/video5.png.png'
import Footer from '../Components/Footer'
import i1 from '../Assets/s01.png'
import i2 from '../Assets/s02.png'
import i3 from '../Assets/s03.png'
import i4 from '../Assets/s04.png'
import i5 from '../Assets/s05.png'
import i6 from '../Assets/s06.png'
import i7 from '../Assets/s07.png'
import i8 from '../Assets/s08.png'
import i9 from '../Assets/s09.png'
import i10 from '../Assets/s010.png'
import i11 from '../Assets/s011.png'
import i12 from '../Assets/s012.png'
import i13 from '../Assets/s013.png'
import i14 from '../Assets/s014.png'
import i15 from '../Assets/s015.png'
import i16 from '../Assets/s016.png'
import Affiliations1 from '../Assets/logo1.jpg'
import Affiliations2 from '../Assets/logo2.png'
import Affiliations3 from '../Assets/logo3.png'
import Affiliations4 from '../Assets/logo4.png'
import Affiliations5 from '../Assets/logo5.jpeg'
import { useLocation, useNavigate } from 'react-router-dom'
import { Get_Api } from '../Api_Url'
import ContentLoader from 'react-content-loader'
import TopCountry from './HomePage/TopCountry'
import GetSeodata from '../Components/GetSeodata'
import AllRevies from '../Components/AllRevies'
import img1 from '../Assets/1.png'
import imge2 from '../Assets/2.png'
import img3 from '../Assets/3.png'
import imge4 from '../Assets/4.jpeg'
import imge5 from '../Assets/5.jpeg'
import img6 from '../Assets/6.jpeg'
import img7 from '../Assets/7.jpeg'
import AllGallary from '../Components/AllGallary'
import LatestBlogs from '../Components/LatestBlogs'
import AllBanner from '../Components/AllBanner'


function Home() {
        const navigate = useNavigate();
        const [AllDestination, setAllDestination] = useState([]);
        const [IsUploading, setIsUploading] = useState(false);
        const [featureDest, setFeatureDest] = useState([])

        const GetAllDestination = async () => {
                try {
                        setIsUploading(true)
                        const response = await Get_Api(`api/admin/GetAllDestination`)
                        setAllDestination(response?.data)
                        setIsUploading(false)
                } catch (error) {
                        setIsUploading(false)
                        console.log(error)
                }
        }

        const getFeatureDestination = async () => {
                try {
                        setIsUploading(true)
                        const response = await Get_Api(`api/packages/getAllFeaturedDestination`)
                        setFeatureDest(response?.data)
                        setIsUploading(false)
                } catch (error) {
                        setIsUploading(false)
                        console.log(error)
                }
        }

        console.log(featureDest)
        useEffect(() => {
                GetAllDestination();
                getFeatureDestination()
        }, []);


        const destinationdetails = (name, id) => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                navigate(`/destinationdetail/${name}/${id}`)
        }

        const location = useLocation();
        const pageName = location.pathname;

        return (
                <>
                        <Navbar />
                        <GetSeodata PageName={'Home'} />
                        <AllBanner/>
                        <div className='pd-copy1'>
                                <TopCountry />

                                <div className='about-home'>
                                        <div className='about-home-left'>
                                                <img src={img} />
                                        </div>
                                        <div className='about-home-right'>
                                                <h6>About Us</h6>

                                                <h2>Your gateway to amazing<br />
                                                        experiences</h2>
                                                <p>Explera Vacations Co., Ltd. is a premier B2B Destination Management Company (DMC) based in Phuket, Thailand, dedicated to delivering exceptional travel experiences for global clients. Established in June 2022, and backed by 13+ years of expertise in the travel and tourism industry, we are officially accredited by the Tourism Authority of Thailand (TAT). This recognition assures the highest standards of professionalism, service quality, and trustworthiness in the competitive travel market.</p>

                                                <p>As a leading DMC, we specialize in crafting unique and seamless travel experiences across Thailand and beyond. From pristine tropical beaches to cultural landmarks and vibrant cityscapes, Explera Vacations Co., Ltd. blends local expertise with global service standards to design unforgettable journeys. Serving travelers from regions such as Russia, the Middle East, Asia, and Europe, we pride ourselves on delivering tailored travel solutions that cater to every client’s unique needs.</p>

                                                <br />
                                                <br />

                                                <button>Find Tours</button>

                                        </div>
                                </div>
                        </div>


                        <div className='maq'>
                                <div class="marquee">
                                        <div class="marquee-content">
                                                <img src={icon4} />
                                                <h3>Dream Destinations Agency</h3>
                                                <img src={icon5} />
                                                <h3>Dream Destinations Agency</h3>
                                                <img src={icon4} />
                                                <h3>Dream Destinations Agency</h3>
                                                <img src={icon5} />
                                                <h3>Dream Destinations Agency</h3>
                                                <img src={icon4} />
                                                <h3>Dream Destinations Agency</h3>
                                                <img src={icon5} />
                                                <h3>Dream Destinations Agency</h3>
                                        </div>
                                </div>

                        </div>
                        <div className='our-services-home'>
                                <p>Our Services</p>
                                <h3>Where Every Trip is<br />
                                        an <span>Adventure</span></h3>
                                <br />
                                <br />
                                <div className='services-cards'>
                                        <div>

                                                <div className='services-card'>
                                                        <img src={icon6} />
                                                        <h5>HOTELS</h5>

                                                </div>
                                        </div>
                                        <div>
                                                <div className='services-card'>
                                                        <img src={icon6} />
                                                        <h5>
                                                                TRANSFER</h5>
                                                </div>
                                        </div>
                                        <div>
                                                <div className='services-card'>
                                                        <img src={icon6} />
                                                        <h5>
                                                                SIGHTSEEING</h5>
                                                </div>
                                        </div>
                                        <div>
                                                <div className='services-card'>
                                                        <img src={icon6} />
                                                        <h5>ACTIVITIES</h5>
                                                </div>
                                        </div>
                                        <div>
                                                <div className='services-card'>
                                                        <img src={icon6} />
                                                        <h5>MICE</h5>
                                                </div>
                                        </div>
                                        <div>
                                                <div className='services-card'>
                                                        <img src={icon6} />
                                                        <h5>BUSINESS TRAVEL</h5>
                                                </div>
                                        </div>
                                        <div>
                                                <div className='services-card'>
                                                        <img src={icon6} />
                                                        <h5>LUXURY TRAVEL PROWESS</h5>
                                                </div>
                                        </div>
                                        <div>
                                                <div className='services-card'>
                                                        <img src={icon6} />
                                                        <h5>CULTURAL IMMERSION</h5>
                                                </div>
                                        </div>
                                        <div>
                                                <div className='services-card'>
                                                        <img src={icon6} />
                                                        <h5>LOCAL INSIGHT</h5>
                                                </div>
                                        </div>
                                        <div>
                                                <div className='services-card'>
                                                        <img src={icon6} />
                                                        <h5>INNOVATIVE SOLUTIONS</h5>
                                                </div>
                                        </div>
                                        <div>
                                                <div className='services-card'>
                                                        <img src={icon6} />
                                                        <h5>PROFESSIONAL EXCELLENCE</h5>
                                                </div>
                                        </div>
                                        <div>
                                                <div className='services-card'>
                                                        <img src={icon6} />
                                                        <h5>SUSTAINABLE TOURISM</h5>
                                                </div>
                                        </div>
                                </div>
                        </div>
                        <div className='pd-copy'>
                                <div className='next-adv'>
                                        <div className='next-adv-heading'>
                                                <div className='next-adv-heading-left'>
                                                        <h2>Unlock Your <span>Next Adventure</span></h2>
                                                        <p>We have been operating for over a decade, providing top-notch services to our clients and
                                                                building a strong track record</p>
                                                </div>
                                                <button>View More</button>
                                        </div>
                                        <br />
                                        <br />
                                        <div className='nxt-grid'>
                                                <div className='thai-gallery'>
                                                        <div className='thai-gallery-1'>
                                                        </div>
                                                        <div className='thai-gallery-1 thai-gallery-2'>
                                                        </div>
                                                        <div className='thai-gallery-1 thai-gallery-3'>
                                                        </div>
                                                </div>
                                                <br />
                                                <br />
                                        </div>
                                </div>
                                <div className='whyus'>
                                        <div className='next-adv-heading'>
                                                <div className='next-adv-heading-left'>
                                                        <h4>Why Us</h4>
                                                        <h2>Why  <span>Choose Us</span></h2>
                                                        <p>Whether you’re looking for places for a vacation. We are here to</p>

                                                </div>
                                                <button>View More</button>
                                        </div>
                                        <br />
                                        <br />
                                        <div className='why-div'>
                                                <div className='why-div-left'>
                                                        <img src={img2} />
                                                </div>
                                                <div className='why-div-right'>
                                                        <div className='why-div-right-div'>
                                                                <div className='ult'>
                                                                        <p>01</p>
                                                                        <h3>Official Accreditation</h3>

                                                                </div>
                                                                <div className='ult'>
                                                                        <p>02</p>
                                                                        <h3>Extensive Expertise</h3>

                                                                </div>
                                                                <div className='ult'>
                                                                        <p>03</p>
                                                                        <h3>Diverse Destinations in Thailand</h3>

                                                                </div>
                                                                <div className='ult '>
                                                                        <p>04</p>
                                                                        <h3>Global Reach</h3>

                                                                </div>
                                                                <div className='ult ult0'>
                                                                        <p>05</p>
                                                                        <h3>Innovative B2B Solutions</h3>

                                                                </div>
                                                        </div>

                                                </div>
                                        </div>
                                </div>

                                <div className='FeaturedDestination'>
                                        <div className='FeaturedDestination-heading'>
                                                <p>Featured Destination</p>
                                                <h3>Turning <span>Dreams</span> into<br />
                                                        Destinations</h3>
                                        </div>
                                        <br />
                                        <br />
                                        <div className='FeaturedDestination-cards'>
                                                {IsUploading ? (
                                                        <ContentLoader
                                                                speed={2}
                                                                width={600}
                                                                height={400}
                                                                viewBox="0 0 600 400"
                                                                backgroundColor="#f3f3f3"
                                                                foregroundColor="#ecebeb"
                                                        >
                                                                <rect x="484" y="38" rx="0" ry="0" width="4" height="6" />
                                                                <rect x="242" y="39" rx="0" ry="0" width="166" height="267" />
                                                                <rect x="58" y="36" rx="0" ry="0" width="166" height="270" />
                                                                <rect x="427" y="39" rx="0" ry="0" width="166" height="261" />
                                                        </ContentLoader>
                                                ) : (
                                                        // featureDest?.map((Destination, index) => (
                                                        //         <div onClick={() => { destinationdetails(Destination?._id) }} key={index} className='Featured-card'>
                                                        //                 <img src={Destination?.BannerImage} />
                                                        //                 <div className='Featured-text'>
                                                        //                         <h2>{Destination?.DestinationName}</h2>
                                                        //                         <p><i class="bi bi-geo-alt-fill"></i>{Destination?.Country?.Name}</p>
                                                        //                         <div className='Featured-price'>
                                                        //                                 <h4>Rs. {Destination?.Price}</h4>
                                                        //                                 <h6><i class="bi bi-clock"></i>{Destination?.Days} days</h6>
                                                        //                         </div>
                                                        //                 </div>
                                                        //         </div>
                                                        // ))
                                                        featureDest?.map((Destination, index) => (
                                                                <div onClick={() => { destinationdetails(Destination?.City?.name, Destination?.DestinationName) }} key={index} className='Featured-card'>
                                                                        <img src={Destination?.BannerImage} alt={Destination?.DestinationName} />
                                                                        <div className='Featured-text'>
                                                                                <h2>{Destination?.DestinationName}</h2>
                                                                                <p><i className="bi bi-geo-alt-fill"></i> {Destination?.Country || "Unknown Country"}</p>
                                                                                <div className='Featured-price'>
                                                                                        <h4>{Destination?.Price}</h4>
                                                                                        <h6><i className="bi bi-clock"></i> {Destination?.Days} days</h6>
                                                                                </div>
                                                                        </div>
                                                                </div>
                                                        ))

                                                )}
                                        </div>

                                        <br />
                                        <br />
                                        <div className='line-btn'>
                                                <div className='line'></div>
                                                <button>View All</button>
                                                <div className='line'></div>

                                        </div>
                                </div>
                        </div>

                        <div className='Testimonials'>
                                <div className='Testimonials-left'>
                                        <img src={img4} />

                                </div>
                                <div className='Testimonials-right'>
                                        <p>Clients Testimonials</p>
                                        <h3>Our Client <span>Reviews</span></h3>
                                        <br />
                                        <br />
                                        <AllRevies />
                                </div>
                        </div>
                        <div className='pd-copy'>
                                <AllGallary />
                                <LatestBlogs />

                                <div className='Accreditations'>
                                        <h3>Associate Hotel Partners</h3>
                                        <h4>Grab the special B2B deals on Hotels, Resorts, Villas & Apartments all over <br /> Thailand.</h4>
                                        <div class="marquee2">
                                                <div class="marquee-content">
                                                        <img src={i1} />
                                                        <img src={i2} />
                                                        <img src={i3} />
                                                        <img src={i4} />
                                                        <img src={i5} />
                                                        <img src={i6} />
                                                        <img src={i7} />
                                                        <img src={i8} />
                                                        <img src={i9} />
                                                        <img src={i10} />
                                                        <img src={i11} />
                                                        <img src={i12} />
                                                        <img src={i13} />
                                                        <img src={i14} />
                                                        <img src={i15} />
                                                        <img src={i16} />
                                                        <img src={i1} />
                                                        <img src={i2} />
                                                        <img src={i3} />
                                                        <img src={i4} />
                                                        <img src={i5} />
                                                        <img src={i6} />
                                                        <img src={i7} />
                                                        <img src={i8} />
                                                        <img src={i9} />
                                                        <img src={i10} />
                                                        <img src={i11} />
                                                        <img src={i12} />
                                                        <img src={i13} />
                                                        <img src={i14} />
                                                        <img src={i15} />
                                                        <img src={i16} />
                                                        <img src={i1} />
                                                        <img src={i2} />
                                                        <img src={i3} />
                                                        <img src={i4} />
                                                        <img src={i5} />
                                                        <img src={i6} />
                                                        <img src={i7} />
                                                        <img src={i8} />
                                                        <img src={i9} />
                                                        <img src={i10} />
                                                        <img src={i11} />
                                                        <img src={i12} />
                                                        <img src={i13} />
                                                        <img src={i14} />
                                                        <img src={i15} />
                                                        <img src={i16} />
                                                </div>
                                        </div>
                                </div>
                                <br/>
                                <div className='Accreditations'>
                                        <h3>Associate Activity & <br /> Entertainment Partners</h3>
                                        <h4>Grab the special B2B deals on Attractions & Activities all over Thailand.</h4>
                                        <div class="marquee2">
                                                <div class="marquee-content1">
                                                        <img src={img1} />
                                                        <img src={imge2} />
                                                        <img src={img3} />
                                                        <img src={imge4} />
                                                        <img src={imge5} />
                                                        <img src={img6} />
                                                        <img src={img7} />
                                                        <img src={img1} />
                                                        <img src={imge2} />
                                                        <img src={img3} />
                                                        <img src={imge4} />
                                                        <img src={imge5} />
                                                        <img src={img6} />
                                                        <img src={img7} />
                                                </div>
                                        </div>
                                </div>
                                <br/>
                                <br/>
                                <br/>
                                <div className='Accreditations'>
                                        <h3>Our Affiliations</h3>
                                        <br />
                                        <div className='Affiliations-img'>
                                                <img src={Affiliations1} />
                                                <img src={Affiliations2} />
                                                <img src={Affiliations3} />
                                                <img src={Affiliations4} />
                                                <img src={Affiliations5} />
                                        </div>

                                </div>
                        </div>


                        <Footer />
                </>
        )
}

export default Home